
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';


const BarChartSa = ({ abonos }) => {

    const ahorro = abonos.filter(a => a.ahorro_pagado == true)
        .reduce((total, a) => total + a.cantidad, 0);

    const faltante = abonos.filter(a => a.ahorro_pagado == false)
        .reduce((total, a) => total + a.cantidad, 0);

    // Datos de ejemplo
    const data = [
        { name: 'Cantidad Ahorrando', AHORRO: ahorro, FALTANTE: faltante },
    ];

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="p-2 border rounded bg-white shadow-sm">
                    <strong>{label}</strong>
                    <ul className="list-unstyled m-0">
                        {payload.map((entry, index) => (
                            <li key={index} style={{ color: entry.color }}>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        width: 10,
                                        height: 10,
                                        backgroundColor: entry.color,
                                        marginRight: 6,
                                        borderRadius: 2,
                                    }}
                                ></span>
                                {entry.name}: {formatCurrency(entry.value)}
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }

        return null;
    };

    const formatCurrency = (value) =>
        new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2,
        }).format(value);

    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        <h4 className="text-center mb-4">Ahorro</h4>
                        <div style={{ width: '100%', height: 300 }}>
                            <ResponsiveContainer>
                                <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend />
                                    <Bar dataKey="AHORRO" fill="#00c462" />
                                    <Bar dataKey="FALTANTE" fill="#c40000" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}


export default BarChartSa